/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/components/users-list/users-list.component.scss */
.mat-mdc-list-base {
  padding-top: 0;
}
/*# sourceMappingURL=users-list.component.css.map */
